// OfferGrid.tsx
import React from "react";
import { Box } from "@vinomofo/components";
import styled from "styled-components";
import { OfferCard, TwoColumnOfferCard } from "../../offer-card";
import { offerCardPropsFromVinoDataOffer } from "../../../transformers/vino-data/offer-card";
import { isFlagEnabled } from "../../../utils/is-flag-enabled";
import { adBlock } from "../ad-block/AdBlock";

type OffersCollectionProps = {
  eligibleOffers: unknown[];
  loading?: boolean;
  columns?: number;
  mb?: number;
};

const StyledOfferGrid = styled(Box)<{
  columns: number;
  neaten?: boolean;
}>`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: ${({ neaten }) => (!neaten ? "60px 10px" : "30px 8px")};

  ${({ neaten }) =>
    neaten && {
      paddingTop: "0.8em",
    }}

  @media ${({ theme }) => theme.mq.min.tablet} {
    grid-template-columns: repeat(
      ${({ columns = 3 }) => columns},
      minmax(23.8%, 1fr)
    );
    grid-gap: ${({ neaten }) => (!neaten ? "5em 1em" : "1em")};

    ${({ neaten }) =>
      neaten && {
        paddingTop: "0.8em",
      }}
  }

  @media (max-width: 932px) and ((orientation: landscape) or (min-aspect-ratio: 1/1)) {
    grid-template-columns: repeat(3, minmax(calc(100% / 3), 1fr));
  }
`;

export const OffersCollection: React.FC<OffersCollectionProps> = ({
  eligibleOffers,
  loading,
  columns = 4,
  mb = 60,
}) => {
  return (
    <Box minHeight={"520px"}>
      <StyledOfferGrid mb={mb} columns={columns}>
        {eligibleOffers?.map((eventOffer, index) => {
          const { offer } = eventOffer;
          const isOffersCollection = true;

          if (!offer) return adBlock(eventOffer);

          const { productCardLayout } = offer;
          const useOneColumn =
            !productCardLayout ||
            (productCardLayout === "One Column" && index !== 0);

          const sharedProps = {
            ...offerCardPropsFromVinoDataOffer({
              ...offer,
              isOffersCollection,
            }),
            offerJson: offer,
            skeleton: loading,
            height: "100%",
            eventPage: true,
            showCountdown: isFlagEnabled(offer.displayFlags, "SHOW_COUNTDOWN"),
            columns: columns,
          };

          return useOneColumn ? (
            <OfferCard
              key={`${offer.id}-${index}`}
              {...sharedProps}
              isOffersCollection
            />
          ) : (
            <TwoColumnOfferCard
              key={`${offer.id}-${index}`}
              {...sharedProps}
              indexId={index}
            />
          );
        })}
      </StyledOfferGrid>
    </Box>
  );
};
